<ion-progress-bar *ngIf="!secondaryStyleBar" [value]="progress" class="progress-bar" [ngClass]="customClass ? customClass : '' "></ion-progress-bar>
  <!-- Barra de progreso opcional -->
<div *ngIf="secondaryStyleBar" class="relative w-full bg-[#c4eceb] h-[4px] rounded-sm" >
  <div
    class="absolute left-0 top-1/2 -translate-y-1/2 bg-[#90be6d] h-[5px] rounded-sm transition-all duration-500"
    [ngClass]="customClass ? customClass : '' "
    [style.width.%]="progress">
  </div>
</div>

